import React from 'react';
import '../styles/BestellingDatumOverzicht.css';

function OrderProductList({ bestelling, compact = false }) {
  const hasItems = bestelling.regels?.length > 0 || bestelling.vrije_regels?.length > 0;

  if (!hasItems) {
    return <p className="datum-overzicht-empty">Geen producten in deze bestelling.</p>;
  }

  return (
    <ul className={`datum-overzicht-producten ${compact ? 'datum-overzicht-producten--compact' : ''}`}>
      {bestelling.regels?.map((regel, index) => (
        <li key={`r-${bestelling.ID}-${index}`}>
          <span className="datum-overzicht-qty">{regel.hoeveelheid}×</span>
          <span>
            {regel.product}
            {regel.eenheid ? ` (${regel.eenheid})` : ''}
          </span>
        </li>
      ))}
      {bestelling.vrije_regels?.map((regel, index) => (
        <li key={`v-${bestelling.ID}-${index}`} className="datum-overzicht-anders">
          <span className="datum-overzicht-qty">{regel.hoeveelheid}×</span>
          <span>{regel.omschrijving} <em>(Anders)</em></span>
        </li>
      ))}
    </ul>
  );
}

function BestellingDatumOverzicht({
  groepen,
  loading = false,
  compact = false,
  onSelectOrder,
  emptyMessage = 'Nog geen bestellingen geplaatst.',
  title
}) {
  if (loading) {
    return <p className="datum-overzicht-loading">Bestellingen laden...</p>;
  }

  if (!groepen || groepen.length === 0) {
    return <p className="datum-overzicht-empty">{emptyMessage}</p>;
  }

  return (
    <div className={`datum-overzicht ${compact ? 'datum-overzicht--compact' : ''}`}>
      {title && <h3 className="datum-overzicht-title">{title}</h3>}
      {groepen.map((groep) => (
        <section key={groep.leverdatum_id} className="datum-overzicht-groep">
          {!compact && (
            <header className="datum-overzicht-groep-header">
              <h4>{groep.leverdatum}</h4>
              <span className="datum-overzicht-count">
                {groep.bestellingen.length} bestelling{groep.bestellingen.length !== 1 ? 'en' : ''}
              </span>
            </header>
          )}

          <div className="datum-overzicht-bestellingen">
            {groep.bestellingen.map((bestelling) => (
              <article key={bestelling.ID} className="datum-overzicht-bestelling">
                <div className="datum-overzicht-bestelling-header">
                  <div>
                    <strong>#{bestelling.ID}</strong>
                    {!compact && (
                      <span className="datum-overzicht-meta">
                        {' '}· besteld op {bestelling.besteldatum}
                      </span>
                    )}
                  </div>
                  <span className={`status status-${bestelling.status === 0 ? 'open' : 'gesloten'}`}>
                    {bestelling.status === 0 ? 'Open' : 'Gesloten'}
                  </span>
                </div>

                <p className="datum-overzicht-summary">
                  {bestelling.aantal_regels} product{bestelling.aantal_regels !== 1 ? 'en' : ''}
                  {compact && ` · besteld op ${bestelling.besteldatum}`}
                </p>

                <OrderProductList bestelling={bestelling} compact={compact} />

                {bestelling.notitie && (
                  <p className="datum-overzicht-notitie">
                    <strong>Notitie:</strong> {bestelling.notitie}
                  </p>
                )}

                {onSelectOrder && (
                  <button
                    type="button"
                    className="datum-overzicht-detail-btn"
                    onClick={() => onSelectOrder(bestelling.ID)}
                  >
                    Bekijk details
                  </button>
                )}
              </article>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default BestellingDatumOverzicht;
